import styles from "../../styles/Whitepaper.module.scss";
import Head from "next/head";
import { useTranslation } from "../../services/i18n";

export const WhitePaper = () => {
  const t = useTranslation();
  const url = t("whitePaperUrl");
  return (
    <div className={styles.container}>
      <Head>
        <title>WhitePaper</title>
      </Head>
      <div className={styles.wrapper}>
        <div className={styles["flame-wrapper"]}>
          <iframe
            width={960}
            height={700}
            src={url as string}
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default WhitePaper;
